import { useContext } from 'react';

import { AuthContext } from '../../contexts/Auth0Context';

export const useAuth = () => useContext(AuthContext);
